export default {"src":"/_next/static/media/white_location_hover.b7f2b1b7.svg","height":26,"width":20,"blurWidth":0,"blurHeight":0};